import { Learnset } from "./learnset.model";

export class ExamLearnset {
  learnsetId: number;
  name: string;
  isSelected: boolean;
  questionsCount: number;

  constructor(learnsetId: number, name: string, isSelected: boolean, questionsCount: number) {
    this.learnsetId = learnsetId;
    this.name = name;
    this.isSelected = isSelected;
    this.questionsCount = questionsCount;
  }

  public static constructExamLearnset(raw: any): ExamLearnset {
    return new ExamLearnset(
      raw.learnsetId,
      raw.name,
      raw.isSelected,
      raw.questionsCount
    );
  }
}